import { createContext, useContext, useState } from 'react';

const SportContext = createContext();

export const SportProvider = ({ children }) => {
  const [selectedSportId, setSelectedSportId] = useState('0');

  return (
    <SportContext.Provider value={{ selectedSportId, setSelectedSportId }}>
      {children}
    </SportContext.Provider>
  );
};

export const useSport = () => useContext(SportContext);
